export const base64UrlToArrayBuffer = (base64Url) => {
    if (!base64Url) return new ArrayBuffer(0);
    if (base64Url instanceof ArrayBuffer) return base64Url;
    if (ArrayBuffer.isView(base64Url)) return base64Url.buffer;
    if (typeof base64Url !== 'string') return new ArrayBuffer(0);
    const padding = '='.repeat((4 - (base64Url.length % 4)) % 4);
    const base64 = (base64Url + padding).replace(/-/g, '+').replace(/_/g, '/');
    const binary = window.atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
};

export const arrayBufferToBase64Url = (buffer) => {
    if (!buffer) return '';
    const bytes = new Uint8Array(buffer);
    let binary = '';
    bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
    });
    const base64 = window.btoa(binary);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

const mapCredentialDescriptor = (descriptor) => ({
    ...descriptor,
    id: base64UrlToArrayBuffer(descriptor.id),
});

export const preparePublicKeyCreationOptions = (options) => ({
    ...options,
    challenge: base64UrlToArrayBuffer(options.challenge),
    user: options.user
        ? {
            ...options.user,
            id: base64UrlToArrayBuffer(options.user.id),
        }
        : options.user,
    excludeCredentials: (options.excludeCredentials || []).map(mapCredentialDescriptor),
});

export const preparePublicKeyRequestOptions = (options) => ({
    ...options,
    challenge: base64UrlToArrayBuffer(options.challenge),
    allowCredentials: (options.allowCredentials || []).map(mapCredentialDescriptor),
});

export const serializeAttestationResponse = (credential) => ({
    id: credential.id,
    rawId: arrayBufferToBase64Url(credential.rawId),
    type: credential.type,
    response: {
        attestationObject: arrayBufferToBase64Url(credential.response.attestationObject),
        clientDataJSON: arrayBufferToBase64Url(credential.response.clientDataJSON),
        transports: credential.response.getTransports ? credential.response.getTransports() : undefined,
    },
    clientExtensionResults: credential.getClientExtensionResults(),
    authenticatorAttachment: credential.authenticatorAttachment,
});

export const serializeAssertionResponse = (credential) => ({
    id: credential.id,
    rawId: arrayBufferToBase64Url(credential.rawId),
    type: credential.type,
    response: {
        authenticatorData: arrayBufferToBase64Url(credential.response.authenticatorData),
        clientDataJSON: arrayBufferToBase64Url(credential.response.clientDataJSON),
        signature: arrayBufferToBase64Url(credential.response.signature),
        userHandle: credential.response.userHandle
            ? arrayBufferToBase64Url(credential.response.userHandle)
            : null,
    },
    clientExtensionResults: credential.getClientExtensionResults(),
    authenticatorAttachment: credential.authenticatorAttachment,
});
